module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_yakuba-e3c5f6086bb714882eed9f5c54025007.jpg";